<div class="flex flex-col gap-2">
  <!--  -->
  @if(!onlyItem()){
  <div
    class="p-5 mb-3 capitalize bg-red-4 font-roboto-500 text-16 rounded-5 text-grey-1 max-sm:text-13 max-sm:p-3"
  >
    <div class="animate-pulse bg-[#DDDEE0] w-full max-w-268 h-4"></div>
  </div>
  } @for (item of nItems(); track $index) {
  <div
    class="grid items-center grid-cols-7 gap-3 p-1 cursor-pointer rounded-5 max-sm:text-11"
  >
    <div
      class="grid items-center grid-cols-2 col-span-3 max-sm:flex max-sm:gap-1 max-sm:flex-col max-sm:items-start max-sm:col-span-2"
    >
      <div class="animate-pulse bg-[#DDDEE0] max-w-28 w-full h-4"></div>
      <div
        class="flex items-center gap-2 max-sm:gap-1 text-grey-2 font-roboto-600"
      >
        <div
          class="animate-pulse rounded-full bg-[#DDDEE0] w-[24px] h-[24px]"
        ></div>
        <div class="animate-pulse bg-[#DDDEE0] w-full h-4"></div>
      </div>
    </div>

    <div
      class="flex flex-col col-span-3 gap-3 max-sm:gap-1 font-roboto-600 text-blue max-sm:col-span-4"
    >
      <div class="grid grid-cols-12">
        <div class="col-span-2">
          <div
            class="animate-pulse rounded-full bg-[#DDDEE0] w-[24px] h-[24px]"
          ></div>
        </div>
        <div
          class="col-span-9 font-roboto-600 animate-pulse bg-[#DDDEE0] w-full h-4"
        ></div>
        <div
          class="col-span-1 text-end animate-pulse bg-[#DDDEE0] w-full h-4"
        ></div>
      </div>
      <div class="grid grid-cols-12">
        <div class="col-span-2">
          <div
            class="animate-pulse rounded-full bg-[#DDDEE0] w-[24px] h-[24px]"
          ></div>
        </div>
        <div class="col-span-9 animate-pulse bg-[#DDDEE0] w-full h-4"></div>
        <div
          class="col-span-1 text-end animate-pulse bg-[#DDDEE0] w-full h-4"
        ></div>
      </div>
    </div>

    <div class="flex justify-end font-roboto-600">
      <div
        class="rounded-full flex justify-center items-center animate-pulse bg-[#DDDEE0] w-8 h-8 p-3"
      ></div>
    </div>
  </div>

  }
</div>
